import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const MyAlert = ({ open, text, onClose, type, ...rest }) => {
  return (
    <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={() => onClose()} {...rest}>
      <Alert severity={type}>{text}</Alert>
    </Snackbar>
  );
};

export default MyAlert;
